
import { createGameListGetter, createGameLauncher } from "./_xhr-game-utils.js";
import config from "@/config";
import errors from "@/errors";
import Vue from "vue";

export default {
  loading: {
    gamingsoft: false,
    gameplay: false,
    sagaming: false,
    ctgaming: false,
    evolution: false,
    live22: false,
    minigame: false,
    yeebet: false,
    pgsoft: false,
    pretty: false,
    pragmatic: false,
    pragmaticGameList: false,
    joker: false,
    jokerGameList: false,
    w4d: false,
    e2: false,
    spp: false,
    jili: false,
    jiliGameList: false,
    uusl: false,
    uuslGameList: false,
    next: false,
    live22: false,
    live22GameList: false,
    wf: false,
    wfGameList: false,
    epw: false,
    epwGameList: false,
    awc: false,
    awcGameList: false,
    aio: false,
    liveTV: false,
    prg: false,
    onlive: false,
    mt: false,
    foxy: false,
  },

  prg(args) {
    const url = config.prgUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: 'prg'
    };
    return new Promise((resolve, reject) => {
      let canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!('min' in args) || !args.min) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!('max' in args) || !args.max) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!('bet_type' in args) || !args.bet_type) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!('comm_type' in args) || !args.comm_type) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest === true) {
        this.loading.prg = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.prg = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == 'string') {
                feedback.success = res.data.status == '1';
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.value;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.prg = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchGS(args) {
    return createGameLauncher('gs', 'playerIdPassword', this.loading)(args);
  },

  launchL22(args) {
    return createGameLauncher('l22', 'playerIdPassword', this.loading)(args);
  },

  launchGP(args) {
    return createGameLauncher('gp', 'playerIdPassword', this.loading)(args);
  },

  launchSA(args) {
    return createGameLauncher('sa', 'usernameSessionId', this.loading)(args);
  },

  launchCT(args) {
    return createGameLauncher('ct', 'usernameSessionId', this.loading)(args);
  },

  launchPG(args) {
    return createGameLauncher('pg', 'usernameSessionId', this.loading)(args);
  },

  launchEvo(args) {
    return createGameLauncher('evo', 'usernameSessionId', this.loading)(args);
  },

  launchYB(args) {
    return createGameLauncher('yb', 'usernameSessionId', this.loading)(args);
  },

  launchPgs(args) {
    return createGameLauncher('pgs', 'usernameSessionId', this.loading)(args);
  },

  launchEsports2(args) {
    return createGameLauncher('e2', 'usernameSessionId', this.loading)(args);
  },

  launchESP(args) {
    return createGameLauncher('e2', 'usernameSessionId', this.loading)(args);
  },

  getPragmaticGameList(args) {
    return createGameListGetter('pragmatic', this.loading)(args);
  },

  launchPragmatic(args, isLiveCasino) {
    return createGameLauncher('pragmatic', 'usernameSessionId', this.loading)(args, { isLiveCasino });
  },

  launchMiniGame(args) {
    return createGameLauncher('minigame', 'usernameSessionId', this.loading)(args);
  },

  launchW4D(args) {
    return createGameLauncher('w4d', 'usernameSessionId', this.loading)(args);
  },

  getJokerGameList(args) {
    return createGameListGetter('joker', this.loading)(args);
  },

  launchJoker(args) {
    return createGameLauncher('joker', 'usernameSessionId', this.loading)(args);
  },

  launchSimplePlay(args) {
    return createGameLauncher('spp', 'usernameSessionId', this.loading)(args);
  },

  launchSPP(args) {
    return createGameLauncher('spp', 'usernameSessionId', this.loading)(args);
  },

  launchJili(args) {
    return createGameLauncher('jili', 'usernameSessionId', this.loading)(args);
  },

  getJiliGameList(args) {
    return createGameListGetter('jili', this.loading)(args);
  },

  launchUusl(args) {
    return createGameLauncher('uusl', 'usernameSessionId', this.loading)(args);
  },

  getUuslGameList(args) {
    return createGameListGetter('uusl', this.loading)(args);
  },

  launchNextSpin(args) {
    return createGameLauncher('next', 'usernameSessionId', this.loading)(args);
  },

  launchNEXT(args) {
    return createGameLauncher('next', 'usernameSessionId', this.loading)(args);
  },

  launchDbHash(args) {
    return createGameLauncher('dbhash', 'usernameSessionId', this.loading)(args);
  },

  launchDbPoker(args) {
    return createGameLauncher('dbpoker', 'usernameSessionId', this.loading)(args);
  },

  launchWowGaming(args) {
    return createGameLauncher('wow', 'usernameSessionId', this.loading)(args);
  },

  launchAiCasino(args) {
    return createGameLauncher('ai', 'usernameSessionId', this.loading)(args);
  },

  launchLive22(args) {
    return createGameLauncher('live22', 'usernameSessionId', this.loading)(args);
  },

  getLive22GameList(args) {
    return createGameListGetter('live22', this.loading)(args);
  },

  launchWf(args) {
    return createGameLauncher('wf', 'usernameSessionId', this.loading)(args);
  },

  getWfGameList(args) {
    return createGameListGetter('wf', this.loading)(args);
  },

  launchEpw(args) {
    return createGameLauncher('epw', 'usernameSessionId', this.loading)(args);
  },

  getEpwGameList(args) {
    return createGameListGetter('epw', this.loading)(args);
  },

  launchAwc(args) {
    return createGameLauncher('awc', 'usernameSessionId', this.loading)(args);
  },

  getAwcGameList(args) {
    return createGameListGetter('awc', this.loading, { skipValidation: true })(args);
  },

  launchAio(args) {
    return createGameLauncher('aio', 'usernameSessionId', this.loading)(args);
  },

  launchOnlive(args) {
    return createGameLauncher('onlive', 'usernameSessionId', this.loading)(args);
  },

  launchMtCasino(args) {
    return createGameLauncher('mtcasino', 'usernameSessionId', this.loading)(args);
  },

  launchFoxy(args) {
    return createGameLauncher('foxy', 'usernameSessionId', this.loading)(args);
  },

  launchLiveTV(args) {
    const url = config.whiteLabel === 1 ? config.apiTvUrl() : config.liveTvUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      source: "launchLiveTV"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("channel" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("match" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sports" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!args.channel) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }
      if (!args.match) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }
      if (!args.sports) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.liveTV = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.liveTV = false;
            if (res) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to launch LiveTV
                  feedback.success = false;
                  feedback.status = errors.request.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.liveTV = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  }

};
